export const iconFontAwesomeSpinnersBahai = (
	<i className="fa-solid fa-bahai"></i>
);
